import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

import { VideoFrame } from "@/types";

interface InitialState {
  currentFrameIndex: number;
  frames: VideoFrame[];
  isPlaying: boolean;
  currentTime: number;
  duration: number;
}

const createInitialState = (): InitialState => ({
  currentFrameIndex: 0,
  frames: [],
  isPlaying: false,
  currentTime: 0,
  duration: 0,
});

interface VideoEditorState extends InitialState {
  setCurrentFrameIndex: (index: number) => void;
  setFrames: (frames: VideoFrame[]) => void;
  play: () => void;
  pause: () => void;
  setCurrentTime: (time: number) => void;
  setDuration: (duration: number) => void;
  resetState: () => void;
}

export const useVideoEditorState = create<VideoEditorState>()(
  subscribeWithSelector((set) => ({
    ...createInitialState(),

    setCurrentFrameIndex: (currentFrameIndex) => {
      set({ currentFrameIndex });
    },

    setFrames: (frames) => {
      set({ frames });
    },

    play: () => {
      set({ isPlaying: true });
    },

    pause: () => {
      set({ isPlaying: false });
    },

    setCurrentTime: (currentTime) => {
      set({ currentTime });
    },

    setDuration: (duration) => {
      set({ duration });
    },

    resetState: () => {
      set(createInitialState());
    },
  })),
);
